import { useTranslation } from 'next-i18next';
import { MemoizedMyJobCard } from '@components/templates/my-jobs/Card';
import { LinkStyled } from '@components/common/Anchor/LinkStyled';
import { getI18nLinkHref } from '@services/i18nPaths';


// Interface
// ********************************************
export interface EmployerHomeJobsProps {
  locale: Locale;
  items: ApiSchema<'MyJobCard'>[];
}


/**
 * @description Company-context home slot: the employer's top recent own jobs.
 *
 * Renders up to the items it is given (the orchestrator already caps to 3) using the
 * same `MyJobCard` as the /mc/my-jobs list, plus a single "Gestionare candidați" link
 * to the full management view.
 */
export const EmployerHomeJobs = ({ locale, items }: EmployerHomeJobsProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((job) => (
          <MemoizedMyJobCard key={job.id} job={job} locale={locale} />
        ))}
      </div>

      <div className="flex justify-center text-base text-ink md:text-lg">
        <LinkStyled
          href={getI18nLinkHref('/mc/my-jobs/activation-date', locale)}
          styling="none"
          className="text-center underline underline-offset-4"
        >
          {t('mc.candidate_management')}
        </LinkStyled>
      </div>
    </div>
  );
};
